import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";


   export const CreateClassMapping = async (credentials) =>{
   return commonFetch(API_URLS.CREATE_CLASS_MAPPING_APIURL, {
    method: "POST",
    body: credentials,
    requiresAuth: true,
  });
}

  //  export const GetAllClassStrSSubsSecMapping = async (credentials) =>
  // commonFetch(API_URLS.GETALL_CLASS_STREAM_SSTREAM_SEC_MAPPING_APIURL, {
  //   method: "POST",
  //   body: credentials,
  //   requiresAuth: true,
  // });

  export const GetsubjectMappedlist = async (formData) => {
    return commonFetch(`${API_URLS.GET_ALL_CLASS_SUBJECT_MAPPING_APIURL}`, {
      method: "POST",
      body: formData,
      requiresAuth: true,
    });
  };
  export const GetsubjectMapped = async (formData) => {
    return commonFetch(`${API_URLS.GET_ALL_CLASS_SUBJECT_MAPPING_APIURL}`, {
      method: "POST",
      body: formData,
      requiresAuth: true,
    });
  };

export const ClassinsertAndUpdate = async (payload) => {
  return commonFetch(`ClassSection/subject-mapping/insertAndUpdate`, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const DeleteSubjectsMappings = async (formData) => {
  return commonFetch(`ClassSection/DeleteSubjectsMappings`, {
    method: "DELETE",
    requiresAuth: true,
    body: formData,
  });
};

export const AddOrUpdateAssignPeriodClasstoTeacher = async (formData) => {
  return commonFetch(API_URLS.ADD_OR_UPDATE_ASSIGN_CLASS_PERIOD_TO_TEACHER, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};


export const DeleteAssignPeriodClasstoTeacher = async (formData) => {
  return commonFetch(API_URLS.DELETE_ASSIGN_CLASS_PERIOD_TO_TEACHER, {
    method: "DELETE",
    requiresAuth: true,
    body: formData,
  });
};

export const FlagsClassInitiate = async (payload) => {
  return commonFetch(API_URLS.INITIATE_FLAGS, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetActiveClassesActiveStudents = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ACTIVE_CLASSES_ACTIVE_STUDENTS}/${schoolID}/${academicYearID}`, {
    method: "GET",
    requiresAuth: true
  });
};